import screenSizes from "../assets/styles/sass/defines/_mediaQueries.module.scss";

export default screenSizes;
